<template>
	<i v-if="skipImport" :class="correlationWithCDN[type]" :style="{ fontSize: radius }"></i>
	<i
		v-else
		v-html="iconPath"
		:alt="alt"
		:title="title"
		:class="rotate"
		:style="{ width: radius, height: radius, display: 'flex' }"
	/>
</template>

<script setup lang="ts">
	import { computed } from 'vue'

	interface Props {
		icon: string
		type?: 'regular' | 'fill' | 'thin' | 'light'
		radius?: string
		rotate?: '' | 'right' | 'down' | 'left'
		title?: string
		alt?: string
		skipImport?: boolean
	}

	const props = withDefaults(defineProps<Props>(), {
		type: 'regular',
		radius: '16px',
		strokeWidth: 'regular',
		rotate: '',
		title: undefined,
		alt: undefined,
		skipImport: false,
	})

	const modules = import.meta.glob('./dsIcons/*.svg', {
		query: '?raw',
		import: 'default',
		eager: true,
	})

	const correlationWithCDN = {
		regular: `ph ph-${props.icon}`,
		fill: `ph-fill ph-${props.icon}`,
		thin: `ph-thin ph-${props.icon}`,
		light: `ph-light ph-${props.icon}`,
	}

	const iconPath = computed(() => {
		let name = props.type === 'regular' ? props.icon : `${props.icon}-${props.type}`
		const path = `./dsIcons/${name}.svg`
		if (!(path in modules)) return ''
		const svg = modules[path] as string
		return setSvgProperties(svg)
	})

	const setSvgProperties = (svg: string) => {
		svg = svg.replace(/height="[^"]*"/g, `height="${props.radius}"`)
		svg = svg.replace(/width="[^"]*"/g, `width="${props.radius}"`)
		svg = svg.replace(/fill="[^"]*"/g, `fill="currentColor"`)
		return svg
	}
</script>

<style scoped lang="scss">
	.right {
		transform: rotate(90deg);
	}
	.down {
		transform: rotate(180deg);
	}
	.left {
		transform: rotate(270deg);
	}
</style>
